import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import LogState from './context/LogState';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <LogState>
    <App />
  </LogState>
);

reportWebVitals();
